import React from 'react';
import {Image, Typography} from 'antd';
import moment from 'moment';
import Boy from '../../assets/icons/Boy02.svg';
import PikadoSmallLogo from '../../assets/icons/PikadoSmallLogo.svg';
import {getGradeByScore} from '../../constants';
import {Classschool, School, Statistic} from '../../graphql/API';

const {Text} = Typography;

type ReportHeaderProps = {
  school: School;
  selectedClass: Classschool;
  report: Statistic;
};

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  school,
  selectedClass,
  report,
}) => {
  return (
    <div
      className="reportHeader-grid-columns border-bottom"
      style={{
        display: 'grid',
      }}>
      <div style={{display: 'grid', gridTemplateColumns: '0.1fr 1fr'}}>
        <Image
          width={100}
          preview={false}
          src={school.promo?.thumbnailUri ? school.promo?.thumbnailUri : Boy}
          style={{display: 'inline-block'}}
          wrapperStyle={{verticalAlign: 'top', padding: 10}}
        />
        <div style={{marginLeft: 20, alignSelf: 'center'}}>
          <Text
            style={{
              display: 'block',
              fontSize: 21,
            }}>
            {selectedClass?.name}
          </Text>
          <Text style={{display: 'block'}}>
            {selectedClass.students.length} Employee in Group
          </Text>
          <Text
            style={{
              display: 'block',
              color: '#999999',
            }}>
            Since {moment(school.createdAt).format('MMM. YYYY')}
          </Text>
        </div>
      </div>
      <div
        className="border-end"
        style={{
          display: 'flex',
          gridTemplateColumns: '0.5fr 1fr',
          position: 'relative',
        }}>
        <div className="h-100 px-0 d-flex justify-content-center flex-shrink-0">
          <div
            style={{
              backgroundColor: getGradeByScore(
                selectedClass.statistic?.averageScore
                  ? selectedClass.statistic?.averageScore
                  : 0,
              ).color,
              position: 'relative',
              width: '100px',
              height: '100px',
            }}>
            <Text
              style={{
                color: '#FFFFFF',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: 25,
              }}>
              {
                getGradeByScore(
                  selectedClass.statistic?.averageScore
                    ? selectedClass.statistic?.averageScore
                    : 0,
                ).grade
              }
            </Text>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center flex-grow-1 ms-3">
          <Text
            style={{
              fontFamily: 'Roboto',
              display: 'block',
              fontSize: 16,
              color: '#999999',
              fontWeight: 'normal',
            }}>
            PERFORMANCE
          </Text>
          <Text
            className="fw-bold"
            style={{
              fontSize: 27,
              color: '#40B2F2',
            }}>
            {report?.averageScore}%
          </Text>
        </div>
      </div>
      <div style={{display: 'grid', gridTemplateColumns: '0.1fr 1fr'}}>
        <Image width={100} preview={false} src={PikadoSmallLogo} />
        <div style={{alignSelf: 'center'}}>
          <Text
            style={{
              color: '#999999',
              marginLeft: 20,
              alignSelf: 'center',
              display: 'block',
            }}>
            PikaDo Daily Exercise Report
            <br />
            Version 1.0 Generated on:{`\n`}
          </Text>
          <Text
            style={{
              color: '#EF426B',
              marginLeft: 20,
            }}>
            {moment(report?.fullReportLastGeneratedDate).format(
              'ddd. DD.MM.YYYY',
            ) === 'Invalid date'
              ? 'No reports generated yet.'
              : moment(report?.fullReportLastGeneratedDate).format(
                  'ddd. DD.MM.YYYY',
                )}
          </Text>
        </div>
      </div>
    </div>
  );
};
